export const firebaseConfig = {
  apiKey: 'AIzaSyDJJEBJzkpgjNeFQGGmUkzsNA2vOhnUlwI',
  authDomain: 'login-react-redux.firebaseapp.com',
  databaseURL: 'https://login-react-redux.firebaseio.com/',
  storageBucket: 'login-react-redux.appspot.com'
};



// WEBPACK FOOTER //
// ./src/core/firebase/config.js